import React from 'react';
import LogoAHS from '@static/logo.svg';
import LogoHSA from '@static/logo-hsa.png';
import { useThemeContext } from '@ThemeContext';
import {Ahs2024LogoColor, Button, Hbw210LogoColor} from '@ftdr/blueprint-components-react';
import { hardLogout } from '@helpers/auth.utils';
import Path from '@constants/paths';
import { PROFILE_ERROR } from '@constants/formField-constants';
import { isSmallView } from '@utils';
import {IsTheme, Theme} from "@app/core/featureToggle";

interface Props {}

const ProfileError: React.FC<Props> = () => {
  const theme = useThemeContext();

  const isSmall = isSmallView();

  const getHeaderLogo = () => {
    if (IsTheme(Theme.HBW210)) {
      return <Hbw210LogoColor height={50} />;
    } else if (theme === 'ahs' && IsTheme(Theme.Ahs2024)) {
      return <Ahs2024LogoColor height={50} />;
    } else {
      return (
        <img
          data-testid={`logo-${theme}`}
          className="h-16"
          src={theme === 'hsa' ? LogoHSA : LogoAHS}
        />
      );
    }
  };

  return (
    <div id="profileError" className="container pt-16">
      <div className="flex justify-center">{getHeaderLogo()}</div>
      <h3 className="text-center mt-14 h3">An Error Has Occurred</h3>
      <p className="mt-5 text-center">
        {PROFILE_ERROR}
        <a className="underline" href={Path.ContactUs}>
          support team
        </a>
        .
      </p>

      <div className="flex items-center justify-center mt-10">
        <Button
          id="verify-logout-btn"
          variant="outlined"
          size="small"
          onClick={hardLogout}
          label="Back to Sign Up"
          labelAlign="center"
          width={isSmall ? 'full' : 'auto'}
        />
      </div>
    </div>
  );
};

export default ProfileError;
